import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import {MatAutocomplete} from '@angular/material/autocomplete';
import {FloatLabelType, SubscriptSizing} from '@angular/material/form-field';
import {FormControl} from '@ngneat/reactive-forms';
import {Subscription} from 'rxjs';

let nextUniqueId = 0;

@Directive()
export abstract class ValueEdit implements OnChanges, OnDestroy {
  @Input() form: FormControl<string | number | Date | undefined>;
  @Input() name?: string;
  @Input() label?: string;
  @Input() floatLabel: FloatLabelType = 'auto';
  @Input() placeholder: string;
  @Input() icon?: string;
  @Input() hint?: string;
  @Input() autofocus: boolean;
  @Input() required = false;
  @Input() autocompleteAttr?: string = undefined;
  @Input() matAutocomplete?: MatAutocomplete;
  @Input() errorsTemplate?: TemplateRef<unknown>;
  @Input() prefix?: string;
  @Input() postfix?: string;
  @Input() published = false;
  @Input() readonly = false;
  @Input() enableValidation = true;
  @Input() subscriptSizing: SubscriptSizing = 'dynamic';
  @Output() focused = new EventEmitter<void>();

  @HostBinding('class.showIcon') get showIconClass() {
    return this.icon;
  }

  protected uniqueId = nextUniqueId++;

  protected _subscriptions = new Subscription();
  private _formSubscription = new Subscription();

  constructor(protected _changeDetector: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.form && this.form?.touch$) {
      this._formSubscription.add(
        this.form?.touch$.subscribe(() => {
          this._changeDetector.detectChanges();
        })
      );
    }
  }

  ngOnDestroy() {
    if (!this._subscriptions?.closed) {
      this._subscriptions.unsubscribe();
    }
  }

  clearValue() {
    this.form?.setValue('');
  }

  getName() {
    return [this.name, this.uniqueId].filter((v) => !!v).join(' ');
  }

  get hasValue() {
    return !!this.form?.value;
  }

  get autocomplete() {
    return <MatAutocomplete>this.matAutocomplete;
  }
}
